import { mutate } from "swr";
import { getRequest } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";

export const getCategory = async (pathParams) => {
  const response = await getRequest(apiRoutes.categories, {
    limit: 500,
    sortBy: "rank",
    sort: "DESC",
  }, pathParams);

  return response?.data?.data.categories
};

export const getAllCategories = async (pathParams) => {
  const response = await getRequest(apiRoutes.allCategories, null, pathParams);
  return response?.data?.data.categories
};

export const getCategoryBySlug = async ( { categorySlug }, pathParams = {} ) => {
  const path = apiRoutes.categoryBySlug.replace(":categorySlug", categorySlug);
  const response = await getRequest(path, null, pathParams);
  return response?.data?.data.categoryDetails
}

export const getCategoryBySlugs = async ( { categorySlugs }, pathParams = {} ) => {
  const responses = await Promise.allSettled(categorySlugs.map(slug => getCategoryBySlug({ categorySlug: slug }, pathParams)));
  const data = responses.filter( response => response.status === 'fulfilled').map( response => {
    const categoryData = response.value;
    mutate(`${apiRoutes.categoryBySlug}${categoryData.slug}`, categoryData);
    return categoryData;
  } );

  return data;
}

export const getSubcategories = async ({categorySlug}, pathParams = {}) => {
  const path = apiRoutes.subCategories.replace(":categorySlug", categorySlug);
  const response = await getRequest(path, null, pathParams);
  const subCategories = response?.data?.data?.categories ?? [];
  return subCategories;
}
